import React, { useState } from "react";
import OtpInput from "react-otp-input";
import Modal from "react-modal";

import gasImage from "../assets/images/Untitled.svg";
import gasImg from "../assets/images/logo1.svg";
import closeBtn from "../assets/images/feature/Close.svg";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "1px solid rgb(0 0 0)",
    width: "99%",
    padding: "0px",

    transform: "translate(-50%, -50%)",
  },
};

function VerifyOtp({ modalIsOpen, closeModal, onConfirmOtp }) {
  const [otp, setOtp] = useState("");

  const handleVerifyOtp = () => {
    if (otp.length == 4) {
      onConfirmOtp(otp);
    }
  };
  const handleResendOtp = () => {};

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="VerifyOtp">
          <div className="p-2">
            <img className="mb-3" src={gasImg} />
            <h4>Verify Your Account</h4>
            <p className="otp_text">
              Enter the verification code sent to your phone.
            </p>

            {/* OTP Input Field */}
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={4}
              renderSeparator={<span className="ifensim">-</span>}
              renderInput={(props) => <input {...props} />}
              containerStyle="VerifyOtpInput"
              inputStyle="OtpInput"
            />

            <p className="otp_text mt-2">
              Haven't received the OTP?
              <span className="text-danger resendBtn" style={{cursor: 'pointer'}} onClick={handleResendOtp}>
                {" "}
                Resend OTP{" "}
              </span>
            </p>

            <button onClick={() => handleVerifyOtp()} className="verifyBtn">
              Verify OTP
            </button>
            {/* <p className='otp_text mt-2'>Haven't received the OTP?<span className='text-danger'> Resend OTP </span> </p> */}
          </div>

          {/* Display an Image */}
          <div>
            <img src={gasImage} className="popRelative" alt="Gas logo" />

            <img
              src={closeBtn}
              onClick={closeModal}
              className="popabsolute"
              alt="Close"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default VerifyOtp;
